import React from "react";
import "./AISolutions.css";

import {
    FiArrowRight,
    FiCpu,
    FiMessageSquare,
    FiZap,
    FiBarChart2,
    FiEye,
    FiDatabase,
    FiLayers,
    FiGitBranch,
    FiCheckCircle,
    FiShoppingBag,
    FiHeart,
    FiTruck,
    FiDollarSign,
    FiBriefcase,
    FiSettings,
} from "react-icons/fi";
import Footer from "../../../components/Footer";
import Header from "../../../components/Header";

const AISolutions = () => {
    return (
        <>
        <Header />
        <title>Dropgear IO | AI Solutions</title>
            <div className="ai-solutions-page">

                {/* =====================================================
          HERO
      ===================================================== */}

                <section className="ai-solutions-hero">

                    <div className="ai-solutions-hero-grid">

                        {/* LEFT */}

                        <div className="ai-solutions-hero-content">

                            <span className="ai-solutions-eyebrow">
                                AI SOLUTIONS
                            </span>

                            <h1>
                                AI that turns
                                <span> workflows into action.</span>
                            </h1>

                            <p>
                                Dropgear IO helps businesses bring artificial
                                intelligence into everyday operations through
                                intelligent workflows, AI agents, automation,
                                and connected business systems.
                            </p>

                            <div className="ai-solutions-hero-buttons">

                                <a
                                    href="/contact"
                                    className="ai-primary-btn"
                                >
                                    Talk to an Expert
                                    <FiArrowRight />
                                </a>

                                <a
                                    href="book-demo"
                                    className="ai-secondary-btn"
                                >
                                    Book a Demo
                                </a>

                            </div>

                            <div className="ai-hero-note">
                                <FiCheckCircle />
                                <span>
                                    Designed around practical business workflows
                                </span>
                            </div>

                        </div>


                        {/* RIGHT - AI SYSTEM VISUAL */}

                        <div className="ai-solutions-visual">

                            <div className="ai-orbit ai-orbit-one"></div>
                            <div className="ai-orbit ai-orbit-two"></div>

                            <div className="ai-core-card">

                                <div className="ai-core-top">

                                    <span className="ai-live-dot"></span>

                                    <span>
                                        Dropgear IO AI Engine
                                    </span>

                                    <span className="ai-core-status">
                                        Active
                                    </span>

                                </div>

                                <div className="ai-core-icon">
                                    <FiCpu />
                                </div>

                                <h3>
                                    Intelligent
                                    <br />
                                    Workflow Layer
                                </h3>

                                <p>
                                    Understand. Decide. Act.
                                </p>

                                <div className="ai-core-lines">

                                    <div>
                                        <span></span>
                                        Understanding input
                                    </div>

                                    <div>
                                        <span></span>
                                        Processing context
                                    </div>

                                    <div>
                                        <span></span>
                                        Executing workflow
                                    </div>

                                </div>

                            </div>

                            <div className="ai-floating-card ai-float-one">
                                <FiMessageSquare />
                                <span>AI Conversations</span>
                            </div>

                            <div className="ai-floating-card ai-float-two">
                                <FiGitBranch />
                                <span>Workflow Automation</span>
                            </div>

                            <div className="ai-floating-card ai-float-three">
                                <FiBarChart2 />
                                <span>Business Intelligence</span>
                            </div>

                        </div>

                    </div>

                </section>


                {/* =====================================================
          INTRO
      ===================================================== */}

                <section className="ai-solutions-intro">

                    <div className="ai-section-container">

                        <div className="ai-section-heading">

                            <span>
                                ONE PLATFORM. MANY POSSIBILITIES.
                            </span>

                            <h2>
                                Build AI into the way
                                <br />
                                <strong>your business works.</strong>
                            </h2>

                            <p>
                                AI becomes more useful when it is connected
                                to real processes. Dropgear IO focuses on applying
                                AI where it can understand information, assist
                                teams, automate repetitive work, and help
                                move workflows forward.
                            </p>

                        </div>


                        <div className="ai-intro-stats">

                            <div>
                                <strong>01</strong>
                                <span>Understand</span>
                                <p>
                                    AI interprets information and business context.
                                </p>
                            </div>

                            <div>
                                <strong>02</strong>
                                <span>Decide</span>
                                <p>
                                    Intelligence helps determine the next step.
                                </p>
                            </div>

                            <div>
                                <strong>03</strong>
                                <span>Act</span>
                                <p>
                                    Workflows can trigger defined actions.
                                </p>
                            </div>

                        </div>

                    </div>

                </section>


                {/* =====================================================
          SOLUTIONS
      ===================================================== */}

                <section
                    id="solutions"
                    className="ai-solutions-section"
                >

                    <div className="ai-section-container">

                        <div className="ai-section-title">

                            <span>
                                OUR AI SOLUTIONS
                            </span>

                            <h2>
                                Intelligence built for
                                <br />
                                <strong>real operational work.</strong>
                            </h2>

                            <p>
                                From AI-powered conversations to autonomous
                                workflow assistance, Dropgear IO brings together
                                practical AI capabilities for modern businesses.
                            </p>

                        </div>


                        <div className="ai-solutions-grid">

                            {/* CARD 1 */}

                            <div className="ai-solution-card featured">

                                <div className="ai-solution-icon">
                                    <FiCpu />
                                </div>

                                <span className="ai-card-number">
                                    01
                                </span>

                                <h3>
                                    AI Agents
                                </h3>

                                <p>
                                    Intelligent agents designed to handle defined
                                    tasks, coordinate workflow steps, and assist
                                    teams with operational processes.
                                </p>

                                <ul>
                                    <li>
                                        <FiCheckCircle />
                                        Task assistance
                                    </li>

                                    <li>
                                        <FiCheckCircle />
                                        Workflow coordination
                                    </li>

                                    <li>
                                        <FiCheckCircle />
                                        Context-aware actions
                                    </li>
                                </ul>

                                

                            </div>


                            {/* CARD 2 */}

                            <div className="ai-solution-card">

                                <div className="ai-solution-icon">
                                    <FiZap />
                                </div>

                                <span className="ai-card-number">
                                    02
                                </span>

                                <h3>
                                    AI Automation
                                </h3>

                                <p>
                                    Turn repetitive operational processes into
                                    structured workflows with intelligent automation.
                                </p>

                                <ul>
                                    <li>
                                        <FiCheckCircle />
                                        Process automation
                                    </li>

                                    <li>
                                        <FiCheckCircle />
                                        Rule-based actions
                                    </li>

                                    <li>
                                        <FiCheckCircle />
                                        Workflow triggers
                                    </li>
                                </ul>

                               

                            </div>


                            {/* CARD 3 */}

                            <div className="ai-solution-card">

                                <div className="ai-solution-icon">
                                    <FiMessageSquare />
                                </div>

                                <span className="ai-card-number">
                                    03
                                </span>

                                <h3>
                                    Conversational AI
                                </h3>

                                <p>
                                    Create AI-powered interactions that help
                                    customers and teams access information and
                                    complete defined tasks.
                                </p>

                                <ul>
                                    <li>
                                        <FiCheckCircle />
                                        AI assistants
                                    </li>

                                    <li>
                                        <FiCheckCircle />
                                        Natural language interaction
                                    </li>

                                    <li>
                                        <FiCheckCircle />
                                        Context-aware responses
                                    </li>
                                </ul>

                                

                            </div>


                            {/* CARD 4 */}

                            <div className="ai-solution-card">

                                <div className="ai-solution-icon">
                                    <FiBarChart2 />
                                </div>

                                <span className="ai-card-number">
                                    04
                                </span>

                                <h3>
                                    AI Analytics
                                </h3>

                                <p>
                                    Transform business information into useful
                                    insights that can help teams understand
                                    operations and make informed decisions.
                                </p>

                                <ul>
                                    <li>
                                        <FiCheckCircle />
                                        Information analysis
                                    </li>

                                    <li>
                                        <FiCheckCircle />
                                        Pattern identification
                                    </li>

                                    <li>
                                        <FiCheckCircle />
                                        Decision support
                                    </li>
                                </ul>

                              

                            </div>


                            {/* CARD 5 */}

                            <div className="ai-solution-card">

                                <div className="ai-solution-icon">
                                    <FiEye />
                                </div>

                                <span className="ai-card-number">
                                    05
                                </span>

                                <h3>
                                    AI Vision
                                </h3>

                                <p>
                                    Explore computer vision workflows for
                                    situations where visual information can become
                                    part of a business process.
                                </p>

                                <ul>
                                    <li>
                                        <FiCheckCircle />
                                        Image understanding
                                    </li>

                                    <li>
                                        <FiCheckCircle />
                                        Visual information processing
                                    </li>

                                    <li>
                                        <FiCheckCircle />
                                        Workflow integration
                                    </li>
                                </ul>

                                

                            </div>


                            {/* CARD 6 */}

                            <div className="ai-solution-card">

                                <div className="ai-solution-icon">
                                    <FiDatabase />
                                </div>

                                <span className="ai-card-number">
                                    06
                                </span>

                                <h3>
                                    Intelligent Data
                                </h3>

                                <p>
                                    Bring AI closer to business information so
                                    teams can work with data more naturally and
                                    efficiently.
                                </p>

                                <ul>
                                    <li>
                                        <FiCheckCircle />
                                        Information extraction
                                    </li>

                                    <li>
                                        <FiCheckCircle />
                                        Data processing
                                    </li>

                                    <li>
                                        <FiCheckCircle />
                                        Knowledge workflows
                                    </li>
                                </ul>

                                

                            </div>

                        </div>

                    </div>

                </section>


                {/* =====================================================
          HOW AI WORKS
      ===================================================== */}

                <section className="ai-workflow-section">

                    <div className="ai-section-container">

                        <div className="ai-workflow-heading">

                            <span>
                                FROM INTELLIGENCE TO ACTION
                            </span>

                            <h2>
                                AI that fits into
                                <br />
                                <strong>your workflow.</strong>
                            </h2>

                            <p>
                                Instead of treating AI as a separate tool,
                                Dropgear IO connects intelligence with the
                                processes your teams already perform.
                            </p>

                        </div>


                        <div className="ai-workflow">

                            <div className="ai-work-step">

                                <div className="ai-step-number">
                                    01
                                </div>

                                <div className="ai-step-icon">
                                    <FiMessageSquare />
                                </div>

                                <h3>
                                    Input
                                </h3>

                                <p>
                                    Information enters the workflow through
                                    conversations, applications, forms, data,
                                    or other connected sources.
                                </p>

                            </div>


                            <div className="ai-work-line"></div>


                            <div className="ai-work-step">

                                <div className="ai-step-number">
                                    02
                                </div>

                                <div className="ai-step-icon">
                                    <FiCpu />
                                </div>

                                <h3>
                                    Intelligence
                                </h3>

                                <p>
                                    AI processes the available context and
                                    determines what information or action
                                    is relevant.
                                </p>

                            </div>


                            <div className="ai-work-line"></div>


                            <div className="ai-work-step">

                                <div className="ai-step-number">
                                    03
                                </div>

                                <div className="ai-step-icon">
                                    <FiGitBranch />
                                </div>

                                <h3>
                                    Workflow
                                </h3>

                                <p>
                                    The system follows defined workflow logic
                                    to move the process toward its next step.
                                </p>

                            </div>


                            <div className="ai-work-line"></div>


                            <div className="ai-work-step">

                                <div className="ai-step-number">
                                    04
                                </div>

                                <div className="ai-step-icon">
                                    <FiZap />
                                </div>

                                <h3>
                                    Action
                                </h3>

                                <p>
                                    The workflow can trigger a defined action,
                                    notify a team, update information, or
                                    request human involvement.
                                </p>

                            </div>

                        </div>

                    </div>

                </section>


                {/* =====================================================
          INDUSTRIES
      ===================================================== */}

                <section className="ai-industries-section">

                    <div className="ai-section-container">

                        <div className="ai-section-title centered">

                            <span>
                                BUILT AROUND BUSINESS CONTEXT
                            </span>

                            <h2>
                                AI for the way
                                <br />
                                <strong>different industries operate.</strong>
                            </h2>

                            <p>
                                Every industry has different workflows,
                                challenges, and operational requirements.
                                Dropgear's IO approach is designed around that
                                context.
                            </p>

                        </div>


                        <div className="ai-industries-grid">

                            <div className="ai-industry-card">
                                <FiShoppingBag />
                                <h3>Retail & Ecommerce</h3>
                                <p>
                                    Customer interactions, order workflows,
                                    product information, and operational assistance.
                                </p>
                                <span>01</span>
                            </div>


                            <div className="ai-industry-card">
                                <FiHeart />
                                <h3>Healthcare</h3>
                                <p>
                                    Information workflows, administrative
                                    assistance, and structured operational tasks.
                                </p>
                                <span>02</span>
                            </div>


                            <div className="ai-industry-card">
                                <FiTruck />
                                <h3>Logistics</h3>
                                <p>
                                    Workflow coordination, information handling,
                                    and operational process assistance.
                                </p>
                                <span>03</span>
                            </div>


                            <div className="ai-industry-card">
                                <FiDollarSign />
                                <h3>Finance</h3>
                                <p>
                                    Information processing, workflow support,
                                    and decision assistance.
                                </p>
                                <span>04</span>
                            </div>


                            <div className="ai-industry-card">
                                <FiBriefcase />
                                <h3>Professional Services</h3>
                                <p>
                                    Client workflows, knowledge access,
                                    document processes, and team assistance.
                                </p>
                                <span>05</span>
                            </div>


                            <div className="ai-industry-card">
                                <FiSettings />
                                <h3>Enterprise Operations</h3>
                                <p>
                                    Connect AI capabilities with complex internal
                                    processes and operational workflows.
                                </p>
                                <span>06</span>
                            </div>

                        </div>

                    </div>

                </section>


                {/* =====================================================
          CTA
      ===================================================== */}

                <section className="ai-solutions-cta">

                    <div className="ai-cta-glow"></div>

                    <div className="ai-cta-content">

                        <span>
                            READY TO EXPLORE AI?
                        </span>

                        <h2>
                            Find where AI can
                            <br />
                            move your business forward.
                        </h2>

                        <p>
                            Tell us about your workflow, challenge, or
                            automation goal. We can explore where intelligent
                            systems could create practical value.
                        </p>

                        <a
                            href="/contact"
                            className="ai-cta-btn"
                        >
                            Start a Conversation
                            <FiArrowRight />
                        </a>

                    </div>

                </section>

            </div>

            <Footer />
        </>

    );
};

export default AISolutions;